<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :show-close="false"
    width="400px"
    :before-close="handleClose"
    class="dialog__header--remove"
  >
    <span v-html="message"></span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{btnCancel}}</el-button>
      <el-button type="primary" @click="handleConfirm">{{btnOk}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: 'ConfirmDialog',
    data () {
      return {
        dialogVisible: false,
        message: '',
        btnCancel: 'キャンセル',
        btnOk: 'OK'
      }
    },
    methods: {
      open (options) {
        this.message = options.message ? options.message : this.message
        this.btnCancel = options.btnCancel ? options.btnCancel : this.btnCancel
        this.btnOk = options.btnOk ? options.btnOk : this.btnOk

        this.dialogVisible = true
        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      },
      handleConfirm () {
        this.resolve(true)
        this.dialogVisible = false
      },
      handleClose () {
        this.resolve(false)
        this.dialogVisible = false
      }
    }
  }
</script>
